import { useLatestProductVersion } from '../../../utility/TreeHelpers'
import { nextVersionName } from '../../TreeActions'
import { IVersionUpdateData } from '../MasterIdSelection'
import { getMasterUpdateValidations } from '../../../masters_management/utility'
import { useAtom } from 'infrastructure/state/jotai.wrapper'
import { useGetProductForId } from '../../../../api/tree.hooks'
import { useCallback, useMemo } from 'react'
import { selectedUpdatesAtom } from './atoms'
import { useGetTree } from '../../TreeRequests'

export function useGetUpdateData() {
  const versionGet = useLatestProductVersion()
  const getProduct = useGetProductForId()
  const getTree = useGetTree()

  return useCallback(
    async (productId: number) => {
      const product = getProduct(productId)
      if (!product?.editable_tree || !product.primary_tree_tree_id) return
      const latestMaster = versionGet(productId)
      if (!latestMaster) return
      const newVersionName = nextVersionName(latestMaster.name)

      const { tree_id: treeId, version_id: versionId } = product.editable_tree

      const tree = await getTree({ treeId, versionId })
      if (!tree) return

      const updateData: IVersionUpdateData = {
        productId,
        newTree: tree,
        newVersionName,
        treeId: product.primary_tree_tree_id,
        versionId: latestMaster.version,
        fromTreeTitle: tree.title,
        toTreeTitle: latestMaster.title,
        valid: true,
        validations: getMasterUpdateValidations(tree),
      }
      return updateData
    },
    [getTree, getProduct, versionGet],
  )
}

export function useUpdatesActions() {
  const [updates, setUpdates] = useAtom(selectedUpdatesAtom)
  const getter = useGetUpdateData()

  return useMemo(() => {
    return {
      addUpdate(updateData: IVersionUpdateData) {
        setUpdates((prev) => [...prev, updateData])
      },
      removeUpdateAtIndex(index: number) {
        setUpdates((prev) => {
          prev.splice(index, 1)
          return [...prev]
        })
      },
      refreshAtIndex: async (index: number) => {
        const update = updates[index]
        const newUpdateData = await getter(update.productId)
        if (!newUpdateData) return

        setUpdates((prev) => [
          ...prev.slice(0, index),
          newUpdateData,
          ...prev.slice(index + 1),
        ])
      },
    }
  }, [updates, setUpdates, getter])
}
